import {SSLAConfiguration} from "./config";
import * as Path from "./path";
import {SSLAPlugin} from "./plugin";

declare var reqwest: any;

/**
 * Determine what type of course this is based on what files are available.
 */
export class CourseTypeDetector {
    callbackOnDecision: Function;
    availablePlugins:{[id: string]: SSLAPlugin};
    isSCORM: boolean = false;
    scormContents: any;

    attemptPlugin(availablePlugins:{[id: string]: SSLAPlugin}): void {
        let myFunc =  this.finishIfAllChecked.bind(this);
        for (let p in availablePlugins) {
            let callback = function callbackOwner() { return myFunc(); };
            availablePlugins[p].getMainAsset(callback);
        }
    }

    protected finishIfAllChecked(): void {
        // TODO Do we need a priority chain?
        let allChecked = true;
        let courseType = "";
        for (let p in this.availablePlugins) {
            allChecked = allChecked ? this.availablePlugins[p].checked : allChecked;
            courseType = this.availablePlugins[p].contents ? p : courseType;
        }
        if (!allChecked) {
            return;
        }
        this.callbackOnDecision(courseType);
    }

    identify(config: SSLAConfiguration, availablePlugins:{[id: string]: SSLAPlugin}, callbackOnDecision: Function): void {
        this.callbackOnDecision = callbackOnDecision;
        this.availablePlugins = availablePlugins;

        this.attemptPlugin(availablePlugins);
    }
}
